<template>

    <div v-if="mini" class="revision">
        <div class="revision__container revision__container--upload">
            <div class="submission submission--upload" v-for="submission in submissions" >
                <a href="#" @click.prevent="showImage(submission.data.medium)" class="submission__thumb-link" >
                    <img :src="submission.data.thumb" class="submission__thumb" >
                </a>
            </div>
        </div>
    </div>

    <div v-else>
        <h2 v-if="title">{{ title }}</h2>
        <div class="revision" v-for="revision in revisions" >
            <h4 v-if="showVersions && revisions.length > 1" class="tag revision__title revision__title--no-container">{{ revision.title }}</h4>
            <a href="#" v-for="submission in revision.submissions" @click.prevent="showImage(submission.data.medium)" class="submission__image-link" >
                <img :src="submission.data.medium"  class="submission__image" />
            </a>
        </div>
    </div>

</template>


<script>

export default {
    props: {
        title: {},
        submissions: {},
        mini: {
            type: Boolean,
            default: false,
        },
        showVersions: {
            type: Boolean,
            default: false,
        }
    },

    computed: {
        revisions: function() {

            return this.submissions.reduce( (revs, sub) => {

                if ( revs[sub.revision] == null ) {
                    revs[sub.revision] = { title: 'versie ' + (sub.revision + 1), submissions: [] }
                }

                revs[sub.revision].submissions.push(sub)
                return revs
            }, []).filter( r => r != null )

        }
    },


    vuex: {
        actions: {
            showImage: ({dispatch}, image) => {
                dispatch('SHOW_IMAGE', image)
                dispatch('SHOW_MODAL', 'ImageContainer')
            },
        }
    },
}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// Upload.vue?12036305